import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined'
import { Box, Grid, Tab, Tabs, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { selectTodayViewMode } from '../../../state/today'
import { pallete } from '../../../theme'

const sx = {
  container: {
    position: 'sticky',
    zIndex: 100,
    height: '50px',
    top: 0
  },
  tabs: {
    background: pallete.headerTransparentColor,
    height: '50px',
    '& .Mui-selected': {
      color: `${pallete.paperColor} !important`
    },
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    }
  },
  controls: {
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '10px',
    background: pallete.headerTransparentColor,
    '& .MuiToggleButtonGroup-root': {
      '& button': {
        background: pallete.headerTransparentColor,
        color: `${pallete.paperColor}99`,
        border: 'none',
        padding: '6px 8px'
      },
      '& button.Mui-selected': {
        background: pallete.headerColor,
        color: pallete.paperColor
      }
    }
  }
}

export const TodayMenu = () => {
  const view = useSelector((state) => state?.todayMenu?.view ?? 'today')
  const dispatch = useDispatch()

  const handleViewChange = (e, value) => {
    if (value) dispatch(selectTodayViewMode(value))
  }

  return (
    <Box sx={sx.container}>
      <Grid container>
        <Grid item xs={8} sx={sx.tabs}>
          <Tabs
            aria-label="today menu tabs"
            value={0}
            TabIndicatorProps={{ style: { backgroundColor: pallete.headerColor } }}
          >
            <Tab icon={<DashboardOutlinedIcon />} aria-label="All" />
          </Tabs>
        </Grid>
        <Grid item xs={4} sx={sx.controls}>
          <ToggleButtonGroup size="small" value={view} onChange={handleViewChange} exclusive>
            <ToggleButton value="today" sx={{ gap: '4px', fontSize: '0.7rem' }}>
              <CalendarTodayOutlinedIcon fontSize="small" />
              Today
            </ToggleButton>
            <ToggleButton value="week" sx={{ gap: '4px', fontSize: '0.7rem' }}>
              <DateRangeOutlinedIcon fontSize="small" />
              Week
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
    </Box>
  )
}
